import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Log técnico para diagnóstico; a mensagem exibida ao usuário é amigável.
    console.error('[Integratio] Falha na interface', error, info.componentStack);
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="card max-w-lg p-8 text-center">
          <AlertTriangle className="mx-auto h-10 w-10 text-brand-red" aria-hidden />
          <h1 className="mt-4 text-xl font-semibold">Algo inesperado aconteceu</h1>
          <p className="mt-2 text-sm text-brand-slate">
            A tela não pôde ser exibida. Recarregue a página e envie a planilha novamente. Se o problema persistir,
            informe o horário da ocorrência ao suporte.
          </p>
          <button type="button" className="btn-primary mt-6" onClick={() => window.location.reload()}>
            Recarregar aplicação
          </button>
        </div>
      </div>
    );
  }
}
